<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-list v-if="product.edge[property] != null" style="background-color: transparent;">
          <v-subheader>{{label}}</v-subheader>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-img :src="images.demosImageUrl(product.edge[property])" aspect-ratio="2"></v-img>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{product.edge[property].name}}</v-list-tile-title>
              <v-list-tile-sub-title>
                Produkt kód: {{product.edge[property].productCode}} - Cena bm:
                {{product.edge[property].price1}} €
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn flat dark color="primary" @click="openDialog()">
                <v-icon dark>edit</v-icon>
              </v-btn>
              <v-btn flat dark color="error" @click="removeEdge()">
                <v-icon dark>remove</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-list v-else style="background-color: transparent;">
          <v-subheader>{{label}}</v-subheader>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-sub-title>Vyberte hranu</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn flat dark color="primary" @click="openDialog()">
                <v-icon dark>add</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>

    <!-- ***************************************************************** DIALOG ****************************** -->

    <v-dialog v-model="dialog" width="850">
      <v-card>
        <v-toolbar color="primary">
          <v-toolbar-title class="white--text">{{label}}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-list two-line dense>
                <v-subheader>Odporúčané hrany</v-subheader>
                <v-divider class="mt-3"></v-divider>
                <template v-for="(item, index) in recommendedHp">
                  <v-list-tile :key="index" avatar @click="selectHp(item)">
                    <v-list-tile-avatar>
                      <v-img :src="images.demosImageUrl(item)" aspect-ratio="2"></v-img>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>{{item.name}}</v-list-tile-title>
                      <v-list-tile-sub-title>Produkt kód: {{item.productCode}} - Cena bm: {{item.price1}} €</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-flex>
            <v-flex xs12 md6 pa-2>
              <v-list two-line dense>
                <v-text-field
                  :items="allHp"
                  :loading="isLoading"
                  v-model="search"
                  label="Iné hrany"
                  no-data-text
                  no-filter
                  hide-no-data
                  hide-details
                  placeholder="Vyhľadajte svoju hranu"
                  return-object
                ></v-text-field>
                <template v-for="(item, index) in allHp">
                  <v-list-tile :key="index" avatar @click="selectHp(item)">
                    <v-list-tile-avatar>
                      <v-img :src="images.demosImageUrl(item)" aspect-ratio="2"></v-img>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>{{item.name}}</v-list-tile-title>
                      <v-list-tile-sub-title>Produkt kód: {{item.productCode}} - Cena bm: {{item.price1}} €</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">Zatvoriť</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import images from "@/views/cutting/js/images";
import Controller from "@/mixins/controlsMixins";
import CuttingService from "@/services/CuttingService";
export default {
  name: "CuttingEdge",
  mixins: [Controller],
  props: ["product", "edges", "property", "label"],
  components: {},
  data() {
    return {
      dialog: false,
      recommendedHp: [],
      allHp: [],
      isLoading: false,
      search: null,
      doneTypingInterval: 1000,
      typingTimer: null,
      images: images
    };
  },
  methods: {
    test() {
      alert();
    },
    openDialog() {
      if (this.product == null || this.product.material == null) {
        this.openGlobalAlert("Najskôr si vyberte material dosky", "warning");
      } else {
        this.search = localStorage.getItem("lastEdgeMaterial");
        this.findRecommendedHp();
      }
    },
    findRecommendedHp() {
      this.openGlobalLoader("Načítava sa ...");
      new CuttingService()
        .getDecorsHmSearch(
          this.product.material.storageCardId,
          this.product.duplex
            ? this.product.material.thickness * 2
            : this.product.material.thickness
        )
        .then(response => {
          console.log(response.data);
          this.recommendedHp = response.data;
          this.dialog = true;
        })
        .catch(() => {
          this.recommendedHp = [];
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    selectHp(item) {
      this.product.edge[this.property] = item;
      this.dialog = false;
      this.search = null;
      this.allHp = [];
    },
    removeEdge() {
      this.product.edge[this.property] = null;
      this.search = null;
      this.allHp = [];
    },
    findDecor(val) {
      if (this.isLoading || val === "" || val === null) {
        return;
      }

      localStorage.setItem("lastEdgeMaterial", val);

      console.log(val);
      this.isLoading = true;

      console.log(this.product.material.thickness);

      new CuttingService()
        .getHp(
          val,
          this.product.duplex
            ? this.product.material.thickness * 2
            : this.product.material.thickness
        )
        .then(r => {
          console.log(r.data);
          this.allHp = r.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  },
  watch: {
    search(val) {
      if (val == null) {
        return;
      }

      window.clearTimeout(this.typingTimer);

      this.typingTimer = setTimeout(
        () => this.findDecor(val),
        this.doneTypingInterval
      );
    }
  }
};
</script>

<style>
</style>